import React, { useState, useEffect } from 'react';
import {
    Row,
    Button
} from 'reactstrap';
import Select from 'react-select';
import CustomSelectInput from '../../../../../../components/common/CustomSelectInput';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI } from '../../../../../../helpers/AxiosAPI';
import { putAPI_Update_Question_Tags } from '../../../../../../constants/APIs';

import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
function TagsForm({
    /** Globle property id from redux */
    propertyId,
    QuestionId,
    handleRoomproduct,
    loadResponse,
    optionName,
    roomTags,
    productTags,
    optionData,
    setType,
    isRoom,
    handleChangeTags
}) {
    const [tagList, setTagList] = useState([]);
    const [selectedTags, setSelectedTags] = useState([]);
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [tags, setTags] = useState([]);
    useEffect(() => {
        if (isRoom !== true) {
            setTagList(productTags);
        }
        else {
            setTagList(roomTags);
        }
        var sel = [];
        if (optionData !== undefined && optionData.categoryTags !== null) {
            if (isRoom === true) {
                if (optionData.categoryTags.roomTags !== null) {
                    optionData.categoryTags.roomTags.map(l => sel.push({ label: l, value: l }));
                }
            }
            else {
                if (optionData.categoryTags.productTags !== null) {
                    optionData.categoryTags.productTags.map(l => sel.push({ label: l, value: l }));
                }
            }
        }
        setSelectedTags(sel);
    }, [productTags, roomTags]);

    const handleTags = (selectedOptions) => {
        setSelectedTags(selectedOptions);
        const categoriesArr = selectedOptions
            .map(elem => elem.value);

        setTags(categoriesArr);
        handleChangeTags({ isRoom: isRoom, tags: categoriesArr });
    };

    // const handleSave = async () => {
    //     var categorytag = optionData.categoryTags === null ? { roomTags: [], productTags: [] } : optionData.categoryTags;
    //     if (isRoom !== true) {
    //         categorytag.productTags = tags;
    //     } else {
    //         categorytag.roomTags = tags;
    //     }
    //     let data = {
    //         CategoryTags: categorytag,
    //     }

    //     // try {
    //     //     return await AxiosAPI({
    //     //         method: 'put',
    //     //         url: `${putAPI_Update_Question_Tags}/${QuestionId}`,
    //     //         data: data,
    //     //     })
    //     //         .then((res) => {
    //     //             if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
    //     //                 && res.data.Messages !== null && res.data.Messages.length > 0) {
    //     //                 setMsg(res.data.Messages);
    //     //                 setOpen(true);
    //     //             }
    //     //             else {
    //     //                 setTimeout(() => {
    //     //                     handleCancel();
    //     //                     loadResponse();
    //     //                 }, 1000)
    //     //             }
    //     //         });
    //     // } catch (error) {
    //     //     console.error(error);
    //     // }
    // };

    // const handleCancel = () => {
    //     handleRoomproduct({ visible: false, type: "" });
    // };
    return (
        <div>
            <Row>
                <Colxx xxs="12" className="mb-3">
                    <Select
                        components={{ Input: CustomSelectInput }}
                        className="react-select"
                        classNamePrefix="react-select"
                        isMulti={true}
                        name="form-field-name"
                        value={selectedTags}
                        onChange={handleTags}
                        options={tagList}
                        placeholder={`Select ${isRoom === true ? "Rooms" : "Product"} Tags`}
                    />
                </Colxx>
            </Row>
            {/* <Row>
                <Colxx xxs="12">
                    <div
                        className="float-right"
                        style={{ marginTop: ' 5px', marginBottom: '5px' }}
                    >
                        <Button
                            color="secondary"
                            className="add-button"
                            size="xs"
                            onClick={handleSave}
                        >
                            Save
                        </Button>
                        <b> </b>
                        <Button
                            color="light"
                            className="add-button"
                            size="xs"
                            onClick={handleCancel}
                        >
                            Cancel
                        </Button>
                    </div>
                </Colxx>
            </Row> */}
            {/* <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation> */}
        </div>
    );
}

const mapStateToProps = ({ settings }) => {
    const { propertyId } = settings;
    return {
        propertyId,
    };
};

export default injectIntl(connect(mapStateToProps)(TagsForm));